/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateVendorTicketDto } from '../../models/create-vendor-ticket-dto';
import { VendorTicketDto } from '../../models/vendor-ticket-dto';

export interface VendorTicketControllerCreate$Params {
  vendorWorkspaceId: string;
      body: CreateVendorTicketDto
}

export function vendorTicketControllerCreate(http: HttpClient, rootUrl: string, params: VendorTicketControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorTicketDto>> {
  const rb = new RequestBuilder(rootUrl, vendorTicketControllerCreate.PATH, 'post');
  if (params) {
    rb.path('vendorWorkspaceId', params.vendorWorkspaceId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VendorTicketDto>;
    })
  );
}

vendorTicketControllerCreate.PATH = '/api/vendor-ticket/{vendorWorkspaceId}';
